@if (appointmentServicesByCat != null) {
  <div class="accordion mt-4" id="appointment-services-accordion" role="region" aria-labelledby="services-section-title">
    <div>
      <app-cw-title class="cbw-select-service-title" id="services-section-title" compTitle="{{ serviceLabelTemplate | translation: templateContent.TEMPLATE_CONTENT: lang }}" />
    </div>

    @if (partner.enable_services_search === 1) {
      <div class="row mt-2">
        <div class="col-lg-12">
          <input
            [(ngModel)]="searchServiceQuery"
            name="searchServiceQuery"
            id="searchServiceQuery"
            type="text"
            aria-label="Search Service"
            class="form-control cbw-input-field"
            placeholder="Enter a service to search"
            (ngModelChange)="onSearchServiceQueryChanged()"
            [placeholder]="'appointments.step1.search_services_helper_text' | translate"
          />
        </div>
      </div>
    }

    <div role="region" aria-label="Services selection">
      <ngb-accordion #accordion="ngbAccordion" [activeIds]="activePanels" aria-label="Services accordion label">
        @for (aServiceGroup of (appointmentServicesByCat | categoryFilter: searchServiceQuery); track aServiceGroup; let i = $index) {
          <ngb-panel cardClass="calio-custom-accordion" id="static-{{ i }}">
            <ng-template ngbPanelHeader let-opened="opened">
              <div
                class="d-flex align-items-center justify-content-between custom-accordion-header"
                (click)="accordion.toggle('static-' + i)"
                (keydown.enter)="accordion.toggle('static-' + i)"
                (keydown.space)="accordion.toggle('static-' + i); $event.preventDefault()"
                role="tab"
                tabindex="0"
                [attr.aria-expanded]="opened"
                [attr.aria-controls]="'panel-' + i"
                [attr.aria-label]="(aServiceGroup?.appointmentServiceCategory | translation: 'name': lang) + ' ' + 'Expand collapse'"
              >
                <div class="pe-3">
                  <app-cw-multi-lang-title [isWordBreakEnabled]="false" [item]="aServiceGroup?.appointmentServiceCategory" lang="{{ lang }}" />
                </div>
                <div>
                  <fa-icon class="icon" [icon]="opened ? 'chevron-up' : 'chevron-down'" aria-hidden="true" />
                </div>
              </div>
            </ng-template>

            <ng-template ngbPanelContent>
              <div id="panel-{{ i }}" role="region" [attr.aria-labelledby]="'static-' + i">
                <form class="form-group service-group" id="checkboxForm" name="appCheckboxForm" #appCheckboxForm="ngForm" aria-label="Services form label">
                  @for (aService of aServiceGroup.aServicesOfCat; track aService; let ind = $index) {
                    <div class="accordion-row d-flex align-items-center" role="group" [attr.aria-labelledby]="'service-' + aService.id">
                      <app-cw-checkbox-radio-button
                        class="w-100"
                        [customId]="aService.id"
                        name="aServices"
                        [value]="aService.name"
                        [checked]="appointmentState.services.indexOf(aService.id) > -1"
                        [isCheckbox]="partner.allow_multiple_services_bookings === 1"
                        [isDisabled]="partner.allow_multiple_services_bookings === 1 && hasCombiServiceSelected ? appointmentState.services.indexOf(aService.id) === -1 : false"
                        labelClass="w-100 justify-content-between"
                        (selectionChange)="onServiceChange($event.event, aService)"
                        [isMobile]="isMobile"
                        [attr.aria-describedby]="'service-details-' + aService.id"
                      >
                        @if (!isMobile) {
                          <div class="service-title pe-3" id="service-{{ aService.id }}">
                            <div class="words-break">
                              <app-cw-multi-lang-title
                                titleClass="cw-custom-title"
                                badgeLabel="{{ 'internal_label' | translate }}"
                                [item]="aService"
                                [lang]="lang"
                                [showBadge]="aService.is_internal === 1"
                              />
                            </div>
                            @if (partner.show_inline_description === 1) {
                              @if (aService.description && aService.description.trim() != '' && aService.description != 'null' && aService.description != null) {
                                <div class="cbw-service-description pe-2" id="service-details-{{ aService.id }}">
                                  {{ aService | translation: 'description': lang }}
                                </div>
                              }
                            }
                          </div>
                          <div class="cbw-service-duration" aria-label="Service duration">
                            <span>
                              @if ((aService.duration | replaceComma | toHour) > 0) {
                                <span>
                                  {{ aService.duration | replaceComma | toHour }}{{ 'common.durationHour' | translate }}
                                </span>
                              }
                              @if ((aService.duration | replaceComma | toMinute) > 0) {
                                <span>
                                  {{ aService.duration | replaceComma | toMinute}}{{ 'common.durationMinute' | translate }}
                                </span>
                              }
                            </span>
                          </div>
                          <div class="cbw-service-price">
                            @if (aService.price > 0) {
                              <div>
                                <span class="cbw-service-price">
                                  @if (aService.is_price_from_activated) {
                                    <span>
                                      {{ 'common.price_from_label' | translate }}
                                    </span>
                                  }
                                  {{ aService.price | calioCurrency: partner?.currency: lang }}
                                </span>
                              </div>
                              @if (aService?.tax && aService?.tax?.rate >= 0) {
                                <div class="cbw-taxes" aria-label="Tax info">
                                  ({{ 'tax_info.' + vatTypeLabelKey(partner.widget_vat_type) | translate }}
                                  @if (vatTypeLabelKey(partner.widget_vat_type) !== 'exclude') {
                                    <span class="cbw-taxes-percentage">{{ aService?.tax?.rate }}%</span>
                                  }
                                  {{ 'tax_info.taxes' | translate }})
                                </div>
                              }
                            }
                            @if (aService.price === 0) {
                              <span aria-label="Free service">{{ 'free' | translate }}</span>
                            }
                          </div>
                          @if (partner.show_inline_description === 0 && aService.description && aService.description.trim() != '' && aService.description != 'null' && aService.description != null) {
                            <div class="cbw-service-desc">
                              @if (partner.show_inline_description === 0) {
                                @if (aService.description && aService.description.trim() != '' && aService.description != 'null' && aService.description != null) {
                                  @if (aService.is_multi_language === 1) {
                                    <app-cw-question-mark [id]="aService.id" [description]="aService | translation: 'description': lang" />
                                  }
                                  @if (aService.is_multi_language === 0) {
                                    <app-cw-question-mark [id]="aService.id" [description]="aService.description" />
                                  }
                                }
                              }
                            </div>
                          }
                        } @else {
                          <div class="d-flex justify-content-between pb-2">
                            <div class="ps-3" id="service-{{ aService.id }}">
                              <div>
                                <app-cw-multi-lang-title
                                  titleClass="cw-custom-mobile-title"
                                  [item]="aService"
                                  [lang]="lang"
                                  [showBadge]="aService.is_internal === 1"
                                  [badgeLabel]="'internal_label' | translate"
                                />
                              </div>
                              @if (partner.show_inline_description === 1) {
                                @if (aService.description && aService.description.trim() != '' && aService.description != 'null' && aService.description != null) {
                                  <div class="cbw-service-description pe-2" id="service-details-{{ aService.id }}">
                                    {{ aService | translation: 'description': lang }}
                                  </div>
                                }
                              }
                            </div>
                          </div>
                          <div class="mobile-text-section d-flex px-3">
                            <div class="cbw-service-duration-mobile" aria-label="Service duration">
                              <span>
                                @if ((aService.duration | replaceComma | toHour) > 0) {
                                  {{ aService.duration | replaceComma | toHour }}{{ 'common.durationHour' | translate }}
                                }
                                @if ((aService.duration | replaceComma | toMinute) > 0) {
                                  {{ aService.duration | replaceComma | toMinute}}{{ 'common.durationMinute' | translate }}
                                }
                              </span>
                            </div>
                            @if (((aService.duration && aService.price > 0) || (aService.duration && aService.price == 0))) {
                              <div class="cbw-pipeline px-2" aria-hidden="true">|</div>
                            }
                            <div class="mobile-text-section cbw-service-price-mobile">
                              @if (aService.price > 0) {
                                <div>
                                  <span>
                                    @if (aService.is_price_from_activated) {
                                      <span>
                                        {{ 'common.price_from_label' | translate }}
                                      </span>
                                    }
                                    {{ aService.price | calioCurrency: partner?.currency: lang }}
                                  </span>
                                </div>
                              }
                              @if (aService.price === 0) {
                                <span aria-label="Free service">{{ 'free' | translate }}</span>
                              }
                            </div>
                          </div>
                        }
                      </app-cw-checkbox-radio-button>

                      @if ((showShortcutButton && !isMobile) || (isMobile && showShortcutButton && appointmentState.services.indexOf(aService.id) > -1)) {
                        <div class="cbw-service-shortcut-next-button">
                          @if (appointmentState.services.indexOf(aService.id) > -1) {
                            <div
                              class="next-arrow-container"
                              (click)="shortcutNavigateToEvent.emit()"
                              (keydown.enter)="shortcutNavigateToEvent.emit()"
                              (keydown.space)="shortcutNavigateToEvent.emit(); $event.preventDefault()"
                              role="button"
                              tabindex="0"
                              [attr.aria-label]="'Next service'"
                            >
                              <span>
                                <fa-icon class="icon cbw-next-arrow-button d-flex" icon="chevron-circle-right" aria-hidden="true" />
                              </span>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                </form>
              </div>
            </ng-template>
          </ngb-panel>
        }
      </ngb-accordion>
    </div>
  </div>
} @else if (!noAppointments) {
  <app-loader aria-label="Loading services" />
}
